import { useAuth } from "@/context/AuthContext";
import DocumentPanel from "@/components/app/DocumentPanel";

const LIBRARY_CATEGORIES = ["Policies", "Handbooks", "Welfare", "Forms", "Other"];

export default function Documents() {
  const { user } = useAuth();
  const isAdmin = user?.role === "admin";
  return (
    <div>
      <div className="mb-8">
        <div className="text-[10px] tracking-[0.3em] uppercase text-[#83B68B]">Club library</div>
        <h1 className="font-display font-black text-4xl md:text-5xl mt-2">Documents</h1>
        <p className="opacity-60 mt-2 text-sm">Policies, handbooks, welfare guidance and downloadable forms. {isAdmin ? "Admin can upload or remove." : "Ask an admin to add anything missing."}</p>
      </div>
      <DocumentPanel
        listEndpoint="/files/document/library"
        uploadEndpoint="/files/document/library"
        canEdit={isAdmin}
        allowPublic={true}
        categories={LIBRARY_CATEGORIES}
        emptyLabel="No documents in the library yet."
        testIdPrefix="library-doc"
      />
    </div>
  );
}
